/** Shared mobile PrecisionAI floating launcher placement. */
export const MOBILE_AI_NUB_SIZE = 52;
export const MOBILE_AI_NUB_RIGHT = 14;
/** Sit just above the floating island nav (pill + bottom inset + gap). */
export const MOBILE_AI_NUB_BOTTOM = 'calc(78px + env(safe-area-inset-bottom, 0px) + 8px)';
